<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='130px' :inline='true'>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.fleetName' size='mini' placeholder='请输入供应商' />
        </el-form-item>
        <el-form-item label='车架号：'>
          <el-input v-model='searchForm.frameNumber' size='mini' placeholder='请输入车架号' />
        </el-form-item>
        <el-form-item label='交单时间：'>
          <el-date-picker
            size='mini'
            v-model='date'
            value-format='yyyy-MM-dd'
            type='daterange'
            unlink-panels
            range-separator='至'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='状态:'>
          <el-select v-model='searchForm.status' size='mini' placeholder='请选择状态'>
            <el-option label='全部' value='' />
            <el-option label='待提交' :value='0' />
            <el-option label='待完成' :value='1' />
            <el-option label='已完成' :value='2' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
            查询
          </el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button v-has='"pc_supplier_receipt_manage_add"' size='small' type='primary'
                     @click='btnClick("add")'>新增
          </el-button>
          <el-button size='small' type='primary' @click='btnClick("batchSubmit")'>提交</el-button>
          <el-button size='small' v-has="'pc_supplier_receipt_manage_confirm'" type='primary' @click='btnClick("batchReceipt")'>确认收单</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'
        @selection-change='selectionChange'
        :row-style="rowStyle">
        <el-table-column type='selection' align='center' min-width='50' />
        <el-table-column label='交单编号' prop='number' align='center' width='160' />
        <el-table-column label='供应商' prop='fleetName' align='center' width='160' />
        <el-table-column label='供应商' prop='fleetName' align='center' width='160' />
        <el-table-column label='品牌' prop='brandName' align='center' />
        <el-table-column label='交单日期' prop='surrenderDate' align='center' width='200' />
        <el-table-column label='快递公司' prop='expressCompany' align='center' />
        <el-table-column label='邮寄单号' prop='expressNumber' align='center' />
        <el-table-column label='交单数量' prop='surrenderNumber' align='center' />
        <el-table-column label='交单备注' prop='surrenderRemarks' align='center' />
        <el-table-column label='收单备注' prop='receiveRemarks' align='center' />
        <el-table-column label='创建时间' prop='createTime' align='center' width='200' />
        <el-table-column label='状态' prop='status' align='center'
                         :formatter='statusFormat' />
        <el-table-column label='交单人' prop='surrenderName' align='center' width='100' />
        <el-table-column label='操作' width='280' align='center'>
          <template slot-scope='scope'>
            <el-button size='mini' class='searchBtn' type='primary'
                       @click='btnClick("info", scope.row)'>
              详情
            </el-button>
            <el-button v-has='"pc_supplier_receipt_manage_update"'
                       v-if='scope.row.status === "0"' size='mini' class='yellow-bg' type='primary'
                       @click='btnClick("edit", scope.row)'>
              修改
            </el-button>
            <el-button v-has='"pc_supplier_receipt_manage_delete"' v-if='scope.row.status === "0"'
                       size='mini' class='resetBtn' type='primary'
                       @click='btnClick("delete", scope.row)'>
              删除
            </el-button>
            <el-button v-has='"pc_supplier_receipt_manage_submit"' v-if='scope.row.status === "0"'
                       size='mini' class='searchBtn' type='primary'
                       @click='btnClick("submit", scope.row)'>
              提交
            </el-button>
            <el-button v-has='"pc_supplier_receipt_manage_confirm"' v-if='scope.row.status === "1"'
                       size='mini' class='searchBtn' type='primary'
                       @click='btnClick("receipt", scope.row)'>
              确认收单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 新增/修改 -->
    <supplier-delivery-form ref='supplierDeliveryFormRef' @searchBtn='searchBtn' />
    <!-- 详情 -->
    <supplier-delivery-info ref='supplierDeliveryInfoRef' />
    <!-- 确认收单 -->
    <supplier-delivery-receipt-form ref='supplierDeliveryReceiptFormRef' @searchBtn='searchBtn' />
  </div>
</template>

<script>
  import SupplierDeliveryForm from './components/form';
  import SupplierDeliveryInfo from './components/info';
  import SupplierDeliveryReceiptForm from './components/receiptForm';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { receiptDelete, receiptList, receiptSubmit } from '@/service/receipt';

  export default {
    name: 'supplierDelivery',
    components: {
      SupplierDeliveryForm,
      SupplierDeliveryInfo,
      SupplierDeliveryReceiptForm,
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        date: ['', ''],
        searchForm: {
          fleetName: '',
          frameNumber: '',
          status: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        selectedData: [],
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
    methods: {
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.supplierDeliveryFormRef.dialogOpen('新增');
            break;
          case 'edit':
            this.$refs.supplierDeliveryFormRef.dialogOpen('编辑', row);
            break;
          case 'info':
            this.$refs.supplierDeliveryInfoRef.dialogOpen(row.id);
            break;
          case 'delete':
            this.delete(row.id);
            break;
          case 'submit':
            this.submit(row.id);
            break;
          case 'batchSubmit':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后提交！');
            const batchSubmitIds = this.selectedData.map(item => item.id)
              .join(',');
            this.submit(batchSubmitIds);
            break;
          case 'receipt':
            this.receipt(row.id, row.surrenderNumber);
            break;
          case 'batchReceipt':
            if (this.selectedData.length === 0) return this.$message.warning('请选择数据后确认收单！');
            const batchReceiptIds = this.selectedData.map(item => item.id)
              .join(',');
            const batchReceiptTotal = this.selectedData.reduce((batchReceiptTotal, item) => (batchReceiptTotal + item.surrenderNumber), 0);
            this.receipt(batchReceiptIds, batchReceiptTotal);
            break;
        }
      },
      /**
       * 删除
       * @param id 当前数据 id
       */
      delete(id) {
        this.$confirm('确认是否删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await receiptDelete(id);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getTableData();
          });
      },
      /**
       * 提交
       * @param ids 当前选中数据 id
       */
      submit(ids) {
        this.$confirm('确认提交当前收单数据吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await receiptSubmit(ids);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.clearSelectedData();
          });
      },
      /**
       * 确认收单
       * @param ids 当前选中数据 id
       * @param total 当前选中数据数量总和
       */
      receipt(ids, total) {
        this.$refs.supplierDeliveryReceiptFormRef.dialogOpen(ids, total);
      },
      // 状态格式化
      statusFormat(row, column, cellValue) {
        switch (cellValue) {
          case '0':
            return '待提交';
          case '1':
            return '待完成';
          case '2':
            return '已完成';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.date = ['', ''];
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await receiptList({
          ...this.searchForm,
          startTime: this.date[0] ? this.date[0] : '',
          endTime: this.date[1] ? this.date[1] : '',
          type: 1,
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      clearSelectedData() {
        this.selectedData = [];
        this.$refs.registerTable.clearSelection();
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const {
          fleetName,
          frameNumber,
          status,
        } = this.searchForm;
        // window.location.href = `${baseUrl}/platform/receiptManage/exportExcel?access_token=${token}&fleetName=${fleetName}&frameNumber=${frameNumber}&status=${status}&startTime=${this.date[0] ? this.date[0] : ''}&endTime=${this.date[1] ? this.date[1] : ''}&type=1`;
        window.exportExcelGet('/platform/receiptManage/exportExcel', `fleetName=${fleetName}&frameNumber=${frameNumber}&status=${status}&startTime=${this.date[0] ? this.date[0] : ''}&endTime=${this.date[1] ? this.date[1] : ''}&type=1`)
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
